import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

const MedicationsIndex = makeAlgoliaIndex(
  'Medications',
  createDetailedValidator<{ name: string }>(),
);

export const useAutoCompleteMedications = (input?: string) =>
  useAlgoliaAutoComplete(MedicationsIndex, input).map(({ name }) => ({
    label: name,
    value: name,
  }));
